module.exports = __webpack_public_path__ + "static/media/background.76465f36.png";